<template>
  <div class="menu-nav">
    <a-dropdown>
      <span class="user-dropdown-link" @click="inform">
        <a-avatar size="small" :src="url" />
        <a class="user-name">{{ name }}</a>
        <i
          v-if="variant === 'dashboard'"
          class="fa-solid fa-chevron-down dashboard-user-chevron"
        />
      </span>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="inform">
            <i class="fa-solid fa-user-tie"></i> {{ $t('text.userInformation') }}
          </a-menu-item>
          <a-menu-item @click="changePassword">
            <i class="fa-solid fa-user-shield"></i> {{ $t('text.changePass') }}
          </a-menu-item>
          <a-menu-item @click="logOut">
            <i class="fa-solid fa-arrow-right-from-bracket"></i> {{ $t('text.logOut') }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, computed } from "vue";

withDefaults(
  defineProps<{
    variant?: "default" | "dashboard";
  }>(),
  { variant: "default" }
);
import store from "@/store/index";
import { useRouter } from "vue-router";
import { useCookies } from "vue3-cookies";
import { USER, USER_LOGINED } from "@/const/cookie";
import commons from "@/utils/Common";
import { CHANGE_PASSWORD, INFORM, SIGN_IN } from '@/const/path'
const { cookies } = useCookies();
const router = useRouter();
const name = ref("");
const url = ref("");
const logOut = async () => {
  commons.logOut();
  router.push({ path: SIGN_IN });
};
const inform = async () => {
  router.push({ path: INFORM });
};
const urlAvatar = computed(() => {
  return store.getters.isUrlAvatar;
});
const changePassword = async () => {
  router.push({ path: CHANGE_PASSWORD });
};
onMounted(() => {
  let user = cookies.get(USER);
  if (user != null && user != undefined) {
    name.value = user.name;
    url.value = user.urlAvatar;
  }
});

watch(urlAvatar, (newValue, oldValue) => {
  url.value = JSON.parse(JSON.stringify(newValue));
});
</script>

<style>
span.lable {
  align-self: flex-end;
  padding-left: 5px;
}

.user-dropdown-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.user-name {
  padding-bottom: 10px !important;
  padding-right: 5px !important;
  background: none !important;
}
</style>
